// import React from "react";
// import "./ApplyNowFloat.css";
// import { FaGraduationCap } from "react-icons/fa";

// export default function ApplyNowFloat() {

//   return (

//     <a
//       href="https://sajili.zetech.ac.ke"
//       className="zetech-apply-float"
//       aria-label="Apply Now"
//     >

//       <span className="zetech-apply-tooltip">

//         Apply Now

//       </span>

//       <FaGraduationCap/>

//     </a>

//   );

// }



import React from "react";
import "./ApplyNowFloat.css";

export default function ApplyNowFloat() {
  return (
    <a
      href="https://sajili.zetech.ac.ke"
      className="zetech-apply-float"
      aria-label="Apply Now"
      target="_blank"
      rel="noopener noreferrer"
    >
      Apply Now
    </a>
  );
}